import React from 'react';
import {
    Linking,
    Platform
} from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';
import { useSelector } from 'react-redux';

import {
    Link,
    View
} from '../../common';
import { getProviders } from '../../selectors/consents';
import { StyledAgreementCheckbox } from '../Visits/snippets/NewVisitModal/snippets.js';

/**
 * Component for displaying a group of clinic consent checkboxes
 * @param {Array} clinicsConsents - array of objects with provider information
 * @param {Object} clinicsConsentsState - checkbox state {providerCode: boolean}
 * @param {Function} onClinicConsentChange - callback when checkbox changes (providerCode, newValue)
 * @param {Array} disabledClinics - array of provider codes for disable checkbox
 */
export const ClinicConsentsGroup = ({
    clinicsConsents,
    clinicsConsentsState,
    onClinicConsentChange,
    disabledClinics = [],
}) => {
    const clinics = useSelector(getProviders);

    if (!clinicsConsents || clinicsConsents.length === 0) {
        return null;
    }

    // Filter only clinics that should be shown
    const visibleClinics = clinicsConsents.filter(clinic => clinic.shouldShow);

    if (visibleClinics.length === 0) {
        return null;
    }

    const openLink = (link) => {
        if (Platform.OS === 'web') {
            window.open(link, '_blank');
        } else {
            Linking.openURL(link);
        }
    };

    return (
        <View style={styles.component}>
            {visibleClinics.map((clinic) => {
                // Get clinic name by providerCode
                const c = clinics?.[clinic.providerCode];
                const clinicName = c?.name ?? clinic?.providerCode;
                const titleComponent = c?.link ? <Link
                    style={Platform.OS !== 'web' ? { marginTop: -2 } : {}}
                    href={() => openLink(c?.link)}>{clinicName}</Link> : clinicName;
                return (
                    <StyledAgreementCheckbox
                        key={clinic.providerCode}
                        // title={clinicName}
                        titleComponent={titleComponent}
                        selected={clinicsConsentsState[clinic.providerCode] || false}
                        onPress={() => {
                            const newValue = !clinicsConsentsState[clinic.providerCode];
                            onClinicConsentChange(clinic.providerCode, newValue);
                        }}
                        containerStyle={styles.container}
                        checkboxStyle={styles.checkbox}
                        disabled={disabledClinics?.includes(clinic?.providerCode)}
                        textStyle={styles.agreementText}
                    />
                );
            })}
        </View>
    );
};

const styles = EStyleSheet.create({
    checkbox: {
        paddingTop: 0,
        marginTop: 0,
        //paddingBottom: 12,
        marginBottom: 12,
        marginRight: 12,
    },
    container: {
        margitTop: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
        borderWidth: 0,
        borderColor: 'blue',
    },
    component: {
        width: '100%',
        marginTop: 20,
    },
    agreementText: {
        ...Platform.select({
            web: { marginTop: -2 },
            ios: { marginTop: 4 },
            android: { marginTop: -3 },
        }),
    },
});
